/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

export const donutChartData = [35, 25, 20, 10, 10];

export const donutChartOptions = {
  labels: ['Meta', 'X', 'TikTok', 'Snapchat', 'Instagram'],
  colors: ['#0075FF', '#00D4FF', '#7B61FF', '#FF6B9D', '#FFB547'],
  chart: {
    width: '100%',
    height: '100%',
    type: 'donut',
  },
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
  },
  legend: {
    show: true,
    position: 'bottom',
    horizontalAlign: 'center',
    fontSize: '12px',
    fontFamily: 'Plus Jakarta Display',
    fontWeight: 400,
    labels: {
      colors: '#A0AEC0',
    },
    markers: {
      width: 12,
      height: 12,
      strokeWidth: 0,
      strokeColor: '#fff',
      fillColors: ['#0075FF', '#00D4FF', '#7B61FF', '#FF6B9D', '#FFB547'],
      radius: 12,
      offsetX: 0,
      offsetY: 0,
    },
    itemMargin: {
      horizontal: 10,
      vertical: 5,
    },
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      donut: {
        size: '70%',
        labels: {
          show: false,
        },
      },
    },
  },
  fill: {
    colors: ['#0075FF', '#00D4FF', '#7B61FF', '#FF6B9D', '#FFB547'],
  },
  tooltip: {
    enabled: true,
    theme: 'dark',
    style: {
      fontSize: '12px',
      fontFamily: 'Plus Jakarta Display',
    },
  },
};
